module.exports = __webpack_public_path__ + "img/logo-ika.fbc5153a.png";